<div class="schedule-sections-container">
  <div class="schedule-workspace">
    <div class="schedule-title">
      ИНФОРМАЦИЯ
    </div>
    <div class="schedule-content"
         #movableElement
         (scroll)="scroll($event)"
    >
      <div class="schedule-content-line"></div>
      <div *ngFor="let item of dates"
           class="schedule-content-info"
           [style]="getActive(item.start, item.end) ? 'color: rgba(198, 160, 82, 1);' : ''"
           [class]="setClass(item.posTop)">
        <div class="schedule-content-info-title">
          {{ item.title }}
        </div>
        <div class="schedule-content-info-info">
          {{ item.text }}
        </div>
        <div class="schedule-content-info-point"></div>
      </div>
      <div class="schedule-content-point"></div>
      <div class="schedule-content-info-button">
        <app-button (click)="emitClick.emit()">
          Регистрация
        </app-button>
      </div>
    </div>
  </div>
</div>
